import { StatusBadge, type Tone } from '../../../billing/StatusBadge';
import type { CommunicationStatus } from '../../../../services/communications';

// toneOverride, not the shared TONES map: 'open' means something different
// here (needs attention) than in billing's StatusBadge (awaiting payment).
const STATUS_TONES: Record<CommunicationStatus, Tone> = {
    open: { bg: 'bg-gray-500' },
    resolved: { bg: 'bg-emerald-600' }
};

export function CommunicationStatusBadge({ status }: { status: CommunicationStatus }) {
    return <StatusBadge status={status} toneOverride={STATUS_TONES} />;
}
